import {Nullable} from '../../../../Common/TypeHelper'
import {MemberJSON} from './MemberInfoDTO'
import {DenyInfo} from './DenyInfoDTO'

export type CurrentMemberDenyAttributeJSON = {
  extensionParamList: Nullable<DenyInfo[]>
  extensionParamAliasList: Nullable<DenyInfo[]>
} & Pick<CurrentMemberDenyAttribute, 'member' | 'comment' | 'applyDate'>

export interface CurrentMemberDenyAttribute {
  member: Pick<MemberJSON, 'familyName' | 'firstName' | 'familyNameKana' | 'firstNameKana'>
  realDenyInfoList: Nullable<DenyInfo[]>
  aliasDenyInfoList: Nullable<DenyInfo[]>
  comment: Nullable<string>
  applyDate: Nullable<string>
}

export class CurrentMemberDenyAttributeDTO implements CurrentMemberDenyAttribute {
  member: Pick<MemberJSON, 'familyName' | 'firstName' | 'familyNameKana' | 'firstNameKana'>
  realDenyInfoList: Nullable<DenyInfo[]>
  aliasDenyInfoList: Nullable<DenyInfo[]>
  comment: Nullable<string>
  applyDate: Nullable<string>

  constructor(
    member: Pick<MemberJSON, 'familyName' | 'firstName' | 'familyNameKana' | 'firstNameKana'>,
    realDenyInfoList: Nullable<DenyInfo[]>,
    aliasDenyInfoList: Nullable<DenyInfo[]>,
    comment: Nullable<string>,
    applyDate: Nullable<string>,
  ) {
    this.member = member
    this.realDenyInfoList = realDenyInfoList
    this.aliasDenyInfoList = aliasDenyInfoList
    this.comment = comment
    this.applyDate = applyDate
  }

  static fromJSON(
    jsonObject: CurrentMemberDenyAttributeJSON,
  ): CurrentMemberDenyAttributeDTO {
    return new CurrentMemberDenyAttributeDTO(
      jsonObject.member,
      jsonObject.extensionParamList,
      jsonObject.extensionParamAliasList,
      jsonObject.comment,
      jsonObject.applyDate,
    )
  }
}
